// Importation des dépendances nécessaires
import React from "react";
import { useAuthContext } from "../context/AuthContext"; // Pour accéder aux données de l'utilisateur et la fonction de déconnexion
import useUserPokemons from "../hooks/Pokemons/useUserPokemon"; // Hook personnalisé pour récupérer les pokémons de l'utilisateur
import styles from "../styles/ProfilePanel.module.css"; // Styles CSS modulaires

// Composant ProfilePanel qui reçoit name, level et onClose comme props
const ProfilePanel = ({ name, level, onClose }) => {
  // Récupération des données utilisateur et de la fonction logout depuis le contexte d'authentification
  const { user, logout } = useAuthContext();
  // Récupération de la liste des pokémons de l'utilisateur et de l'état de chargement
  const { userPokemons, isLoading: userPokemonsLoading } = useUserPokemons();

  // Recherche du Pokémon avec le niveau le plus élevé
  const highestLevelPokemon = userPokemons?.reduce((highest, current) => {
    // Si pas de plus haut niveau encore OU si le pokémon actuel a un niveau plus élevé
    return !highest || current.lvl > highest.lvl ? current : highest;
  }, null); // On commence avec null comme valeur initiale

  return (
    // Container principal du panneau de profil
    <div className={styles.container}>
      {/* Corps du panneau de profil */}
      <div className={styles.bodyBg}></div>
      <div className={styles.profileBody}>
        <div className={styles.trainerBorder}></div>
        {/* Section des informations utilisateur */}
        <div className={styles.userInfos}>
            <p className={styles.username}>{user.username}</p>
            <div className={styles.userImg}>
                <img src={`${user.avatar ? user.avatar : '/assets/icons/user.svg'}`} alt="" />
                <p>Visuel à venir dans une prochaine MàJ</p>
            </div>
            <div className={styles.userDatas}>
                <p>Nombre de pokémons dans l'équipe : {userPokemons?.length}</p>
                <p>Pokémon star : {highestLevelPokemon?.name}</p>
                {/* <p>Nombre de tâches effectuées : à venir </p> */}
            </div>
          {/* Affichage conditionnel du Pokémon de plus haut niveau */}
          <div className={styles.mainPokemon}>
            {highestLevelPokemon && (
              <img src={highestLevelPokemon.illustration} alt="" />
            )}
          </div>
          {/* Affichage du niveau du joueur (passé en props) */}
          <p className={styles.level}>{level}</p>
        </div>
        {/* Section du bouton de déconnexion */}
        <div className={styles.trainerBorderBottom}>
        <button onClick={logout}>Se déconnecter</button>
        </div>


      </div>
              {/* Container du bouton de fermeture */}
              <div className={styles.closeButtonContainer}>
          {/* Bouton de fermeture avec icône SVG */}
          <div className={styles.closeButton} onClick={onClose}>
            <svg
              width="30"
              height="30"
              viewBox="0 0 669 774"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M345.71 0.439453H93.33C78.07 0.439453 65.7 12.8095 65.7 28.0695C65.7 43.3295 78.07 55.6994 93.33 55.6994H345.71C491.47 55.6994 610.33 173.039 612.79 318.229C615.32 467.649 489.08 589.949 339.64 589.949H94.31L95.48 588.829L170.66 513.649C181.45 502.859 181.45 485.359 170.66 474.569C159.87 463.779 142.37 463.779 131.58 474.569L9.04001 597.109C-1.74999 607.899 -1.74999 625.399 9.04001 636.189L138.31 765.459C149.1 776.249 166.6 776.249 177.39 765.459C188.18 754.669 188.18 737.169 177.39 726.379L96.23 645.219H338.85C514.28 645.219 662.75 507.929 667.95 332.579C673.35 150.379 526.71 0.439453 345.71 0.439453Z"
                fill=" rgb(83, 80, 80)"
              />
            </svg>
          </div>
        </div>
    </div>
  );
};

export default ProfilePanel;
